<template>
  <div class="container">
    <el-row :gutter="10" class="header">
      <el-button type="primary" @click="getAllUser" size="mini">查询</el-button>
      <el-button type="primary" @click="emitUserinfoDialogShow" size="mini"
        >添加新账户</el-button
      >
    </el-row>
    <el-row :gutter="10">
      <el-table :data="allUserList" style="width: 100%">
        <el-table-column
          prop="username"
          label="用户名"
          width="180"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="用户组"
          width="180"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ computedUserGroup(scope.row.user_group) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="info"
          label="信息"
          width="180"
          header-align="center"
          align="center"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            width="90"
            label="名字"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            width="90"
            label="联系方式"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="emitUserinfoDialogShow(scope.row)"
              >更改</el-button
            >
            <el-button type="text" @click="workHistory(scope.row)"
              >工作记录</el-button>
            <el-button
              class="danger-text"
              type="text"
              @click="deleteUser(scope.row)"
              :disabled="scope.row.username === 'root'"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="提示" :visible.sync="userinfoDialogShow" width="30%">
      <el-form
        ref="userinfoForm"
        :model="userinfoInstance"
        :rules="rules"
        label-width="80px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="userinfoInstance.username"
            :disabled="editFlag === true"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户组">
          <el-select v-model="userinfoInstance.user_group" placeholder="请选择">
            <el-option
              v-for="item in userGroupOptions"
              :key="item.weight"
              :label="item.group"
              :value="item.weight"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权限管理" v-if="editFlag === true">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="permissionList">
            <el-checkbox
              v-for="item in routerList"
              :label="item.name"
              :key="item.name"
              >{{ item.text }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="editFlag && !editPwd" label="密码">
          <el-button type="text" @click="editPwd = true">修改密码</el-button>
        </el-form-item>
        <el-form-item label="密码" v-if="!editFlag || editPwd" prop="password">
          <el-input
            v-model="userinfoInstance.password"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="checkPass"
          v-if="!editFlag || editPwd"
        >
          <el-input
            v-model="userinfoInstance.checkPass"
            placeholder="确认密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideUserinfoDialog">取 消</el-button>
        <el-button type="primary" @click="addNewUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import {
  apiDeleteUser,
  apiEditUser,
  apiEditUserPermissions,
  apiGetAllUserList,
  apiGetUserPermissions,
  apiRegisterNewUser
} from '@/api';

export default {
  name: "",
  components: {},
  data() {
    const checkPass = (rule, value, callback) => {
      if (value !== this.userinfoInstance.password) {
        callback(new Error("两次密码输入不一致"));
      }
      callback();
    };
    return {
      editPwd: false,
      checkAll: false,
      isIndeterminate: true,
      routerList: [
        { text: "任务管理", name: "taskAdmin" },
        { text: "任务历史", name: "taskHistory" },
        { text: "碗碟管理", name: "dishModel" },
        { text: "碗碟库管理", name: "dishModelManagement" },
        { text: "餐厅碗碟管理", name: "bindCanteen" },
        { text: "数据清洗", name: "dishDataCheck" },
        { text: "支付插件管理", name: "paymentModuleAdmin" },
        { text: "训练任务", name: "trainTask" },
        { text: "批量上传", name: "batchUpload" },
        { text: "回测准确率", name: "backDataAccSummary" },
        // { text: "回测准确率", name: "backDataAcc" },
        { text: "识别框矫正", name: "regionsFix" },
        { text: "餐厅管理", name: "canteenAdmin" },
        { text: "机器管理", name: "machineAdmin" },
        { text: "事件管理", name: "eventManagement" },
        { text: "用户管理", name: "userAdmin" },
        { text: "版本管理", name: "moduleAdmin" },
        { text: "user_key管理", name: "ffi" }
      ],
      permissionList: [],
      userinfoDialogShow: false,
      allUserList: [],
      userGroupOptions: [
        { weight: 1, group: "标注员" },
        { weight: 100, group: "审核员" },
        { weight: 500, group: "次级管理员" },
        { weight: 1000, group: "超级管理员" },
        { weight: 200, group: "部署员" },
        { weight: 300, group: "市场部" }
      ],
      userinfoInstance: {
        username: "",
        user_group: "",
        password: "",
        checkPass: "",
        info: {
          name: "",
          phone: ""
        }
      },
      editFlag: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            pattern: /[a-zA-Z0-9_-]{4,16}/,
            message: "用户名长度需在4~16位之间",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码长度必须大于6位", trigger: "blur" }
        ],
        checkPass: [{ validator: checkPass, trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.setSubTitle("用户管理");
    this.getAllUser();
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    handleCheckAllChange(val) {
      console.log(val);
      this.permissionList = val ? this.routerList.map(a => a.name) : [];
      this.isIndeterminate = false;
    },
    handleClose() {},
    async hideUserinfoDialog() {
      // let res = await apiGetUserPermissions({
      //   username: this.userinfoInstance.username
      // });
      // this.permissionList = res.permission;
      this.userinfoDialogShow = false;
      this.userinfoInstance = {
        username: "",
        user_group: "",
        password: "",
        checkPass: "",
        info: {
          name: "",
          phone: ""
        }
      };
      this.editPwd = false;
      this.checkAll = false;
      this.isIndeterminate = false;
      this.permissionList = [];
      this.editFlag = false;
    },
    workHistory(row) {},
    async emitUserinfoDialogShow(row) {
      if (row.hasOwnProperty("username")) {
        this.editFlag = true;
        this.userinfoInstance = this.$_.cloneDeep(row);
        try {
          let res = await apiGetUserPermissions({ username: this.userinfoInstance.username });
          this.permissionList = res.permission;
        } catch (e) {
          this.$message.error('获取该用户权限失败, ' + e.message);
        }
      }
      this.userinfoDialogShow = true;
    },
    addNewUser() {
      this.$refs["userinfoForm"].validate(async valid => {
        if (valid) {
          if (this.editFlag === false) {
            try {
              await apiRegisterNewUser({
                ...this.userinfoInstance,
                apiKey: this.apiKey
              });
              this.hideUserinfoDialog();
              this.getAllUser();
            } catch (e) {
              console.log(e);
              this.$message.error("新建失败");
              this.hideUserinfoDialog();
            }
          } else {
            try {
              await apiEditUser({
                ...this.userinfoInstance,
                apiKey: this.apiKey
              });
              await apiEditUserPermissions({
                permission: this.permissionList,
                username: this.userinfoInstance.username
              });
              let res = await apiGetUserPermissions({
                username: this.userinfoInstance.username
              });
              this.hideUserinfoDialog();
              this.$message.warning("修改成功");
              this.getAllUser();
              this.editFlag = false;
            } catch (e) {
              console.log(e);
              this.$message.error("修改失败" + e.message);
              this.editFlag = false;
              this.hideUserinfoDialog();
            }
          }
        } else {
          return false;
        }
      });
    },
    deleteUser(row) {
      this.$prompt("请输入root密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator(value) {
          if (!value) {
            return false;
          }
        },
        inputErrorMessage: "请输出root密码"
      })
        .then(async ({ value }) => {
          try {
            await apiDeleteUser({
              root_password: value,
              username: row.username,
              apiKey: this.apiKey
            });
            this.getAllUser();
          } catch (e) {
            console.log(e);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    // editUser (row) {
    //
    // },
    async getAllUser() {
      try {
        try {
          let res = await apiGetAllUserList(this.apiKey);
          this.allUserList = res.user_list;
        } catch (e) {}
      } catch (e) {
        console.log(e);
      }
    },
    computedUserGroup(usergroup) {
      let index = this.$_.findIndex(this.userGroupOptions, function(o) {
        return o.weight === usergroup;
      });
      return this.userGroupOptions[index].group;
    }
  },
  computed: {
    ...mapGetters(["userinfo"]),
    apiKey() {
      return this.userinfo().api_key;
    }
  },
  watch: {
    async userinfoDialogShow(val, oldVal) {
      // console.log(oldVal.username);
      if (val === false) {
        this.userinfoInstance = {
          username: "",
          user_group: "",
          password: "",
          checkPass: "",
          info: {
            name: "",
            phone: ""
          }
        };
        this.editPwd = false;
        this.checkAll = false;
        this.isIndeterminate = false;
        this.permissionList = [];
        this.editFlag = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .header {
    position: absolute;
    top: -35px;
    left: 150px;
  }
  .danger-text {
    color: $danger;
  }
}
</style>
